<label
  [ngClass]="labelClasses"
  *ngIf="label"
  [for]="inputId">
  {{label | translate}}
  <pcs-tooltip *ngIf="labelDetails" icon="info_outline">
    {{labelDetails}}
  </pcs-tooltip>
</label>
<div class="input-wrapper col" [ngClass]="inputWrapperClasses">
  <input
    [autocomplete]="autocomplete"
    [type]="type"
    [ngClass]="inputClasses"
    [id]="inputId"
    [name]="name"
    [value]="value"
    [disabled]="disabled"
    [readonly]="readonly"
    [tabindex]="tabindex"
    [placeholder]="placeholder | translate"
    (input)="onInput($event)"
    (focus)="onFocus()"
    (blur)="onBlur($event)"
    (keydown)="onKeyDown($event)" />
  <pcs-tooltip *ngIf="tooltipForValue && readonly && value" tabIndex="-1">
    {{value}}
  </pcs-tooltip>
</div>
<small
  class="form-text"
  *ngIf="helperText">
  {{helperText | translate}}
</small>
